export default "__VITE_ASSET__df9b78f0__"